import apiClient from '../apiClient';
import { DELETE_AREA_URL } from '../apiUrl';

const deleteAreaApi = Id => {
  return apiClient.delete(DELETE_AREA_URL(Id));
};

export default deleteAreaApi;
